import { DenkerPresenceSwitcher } from "@/workshop/components/canvas/denker-presence-switcher";

export function DenkerPresenceSwitcherPage() {
  return <DenkerPresenceSwitcher />;
}
